import { css, cx } from '@repo/pandacss/styled-system/css';
import Image from 'next/image';

const DOUBLE_SPARKLE_SVG = 'https://www.nerdwallet.com/cdn/banking/spotlight/double-sparkle.svg';

export const SPOTLIGHT_BADGE_HEIGHT_PX = 38;

export const SPOTLIGHT_COMPACT_HEADING_MAX_LENGTH = 55;

type Props = {
  heading: string;
  variant?: 'compact' | 'full';
};

const badgeBaseStyles = css({
  backgroundColor: 'lime.tintLP2',
  display: 'flex',
  flexWrap: 'nowrap',
  minHeight: `[${SPOTLIGHT_BADGE_HEIGHT_PX}px]`,
  alignItems: 'center',
  paddingInlineStart: '4',
  paddingInlineEnd: '4',
  paddingBlockStart: '1',
  paddingBlockEnd: '1',
  borderBottomLeftRadius: 'lg',
  borderBottomRightRadius: 'lg',
  columnGap: '2',
  rowGap: '2',
  boxSizing: 'border-box',
  width: 'fit',
});

const compactBadgeStyles = css({
  minWidth: 'full',
});

const fullBadgeStyles = css({
  maxWidth: 'full',
  minWidth: '0',
});

const compactHeadingStyles = css({
  fontWeight: 'medium',
  fontSize: 'sm',
  lineHeight: 'normal',
  color: 'neutral.black',
  textAlign: 'left',
  whiteSpace: 'nowrap',
});

const fullHeadingStyles = css({
  fontWeight: 'medium',
  fontSize: 'sm',
  lineHeight: 'normal',
  color: 'neutral.black',
  textAlign: 'left',
  minWidth: '0',
  overflowWrap: 'break-word',
});

export function SpotlightBadge({ heading, variant = 'full' }: Props) {
  const isCompact = variant === 'compact';

  return (
    <div
      className={cx(badgeBaseStyles, isCompact ? compactBadgeStyles : fullBadgeStyles)}
      data-testid="spotlight-badge"
    >
      <Image
        src={DOUBLE_SPARKLE_SVG}
        alt=""
        width={31}
        height={23}
        unoptimized
        className={css({ flexShrink: '0' })}
      />
      <span className={isCompact ? compactHeadingStyles : fullHeadingStyles}>{heading}</span>
    </div>
  );
}
